import { Vue } from 'vue-property-decorator'

export class Notify {
  static create(data) {
    Vue.notify({
      group: 'global',
      title: data.title,
      type: data.type,
      text: data.text,
      duration: 5000,
      closeOnClick: true,
    } as unknown)
  }
}
